import $ from "jquery";
import * as React from 'react';
import { ModalCloseButton } from "./ModalCloseButton";
import ModalDialog from './ModalDialog';
import { ErrorData, errorTypes } from '../../constants';

class ModalDialogError extends React.Component {
    constructor(props) {
        super(props);
        this.state = { id: '', errorData: ErrorData, onCloseClick: null };
    }

    componentDidUpdate() {
        if (this.props.hasErrorOccured) {
            $("#" + this.props.id).modal();
        }
    }

    handleClose = () => {
        this.props.onCloseClick();
    }

    render() {
        let message = this.props.errorData ? this.props.errorData.message : '';
        let title = '';
        let errorType = this.props.errorData ? this.props.errorData.errorType : errorTypes.Fatal;
        switch (errorType) {
            case errorTypes.Fatal:
                title = 'Error';
                break;
            case errorTypes.Unauthorized:
                title = 'Unauthorized Process';
                break;
            case errorTypes.Validation:
                title = 'Validation Error';
                break;
            default:
        }

        return (
            <ModalDialog id={this.props.id}
                title={title}
                bodyMessage={message}
                iconName='zap'
                titleClassName='text-danger'
                onCloseClick={this.handleClose}
                footerChild={(
                    <div>
                        <ModalCloseButton value='Close' onClick={this.handleClose} />
                    </div>
                )}>
            </ModalDialog >
        );
    }
}

export default ModalDialogError;


// WEBPACK FOOTER //
// ./src/components/Controls/ModalDialogError.js